<template>
    <div class="container mt-5" style="padding-top:100px">
        <h5>Add jobs to <span style="text-transform: lowercase">{{job_fair_name}}</span></h5>
        <div id="add_jobs" class="bg-white w-100 mt-5 p-1 d-flex justify-content-around align-items-center">
            <b-form-group id="job" class="col-lg-8 mb-0 p-0">
                <v-autocomplete v-model="selected_jobs" label="select jobs" :items="jobs" item-text="text" item-value="id" :searchable="true" clearable chips outlined multiple deletable-chips hide-selected> 
                      <template slot="item" slot-scope="data">
                        <template v-if = typeof(data.item) != 'object'>
                          <v-list-item-content v-text="data.item.text"/>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.text"/>
                            <v-list-item-sub-title v-html="data.item.group"/>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
            </b-form-group>
            <div class="col-lg-4 d-flex">
                <button class="btn btn-primary w-100 mr-5 py-3" @click="addJobs()">
                Add to jobfair
                </button>
                <button class="btn btn-primary w-100 py-3">
                    <a href='/recruit/post-job?jobfair=true' style="color:inherit; text-decoration: none">Post new job</a>
                </button>
            </div>
        </div>
        <div class="job_fair row mt-5" v-if="job_fair_jobs.length">
           <div class="col-11 bg-white">
                <table class="table table-striped" style="white-space: nowrap">
                    <thead>
                        <tr>
                            <th>Job ID</th>
                            <th>Company name</th>
                            <th>Job designation</th>
                            <th>Last date to apply</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="job in job_fair_jobs" :key="job.id">
                            <td>{{job.job_id}}</td>
                            <td>{{job.company_name}}</td>
                            <td>{{job.job_designation}}</td>
                            <td>{{getDate(job.last_date)}}</td>
                            <td>{{getStatus(job.status)}}</td>
                            <td class="px-5" style="font-size: 1.25rem;width: max-content">
                                <span @click="removeJob(job.job_id)"><i class="mdi mdi-delete" v-b-tooltip.hover title="Delete"></i></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
           </div>
       </div>
    </div>
</template>

<script>
export default {
    name: 'manage_jobfair_jobs',
    beforeMount() {
        this.token = this.$cookies.get("hire-employer").token;
        this.jobfair_id = this.$route.params.id
        new this.$apiAction().showJobfair(this.$route.params.id, this.token).then((res) => {
            this.job_fair_name =  res.jobfair.job_fair_name;
        }).catch((err) => {
            console.log(err)
        });
        this.getJobfairJobs();
        this.loadJobs();
    },
    data() {
        return {
            token: null,
            job_fair_name: '',
            jobs: [],
            selected_jobs: null,
            jobfair_id: null,
            job_fair_jobs : [],
            vue_app_url : process.env.VUE_APP_URL
        }
    },
    methods: {
        loadJobs: function() {
            this.jobs = [];
            new this.$apiAction().getAllJobs(this.token).then((res) => {
                    if(res.status == true) {
                        res.jobs.forEach(element => {
                            if(!this.hasDupes(this.job_fair_jobs, element.job_id))
                            {
                                this.jobs.push({text:element.seo_title+'('+element.job_id+')',id:element.job_id})
                            }
                        });
                    }
                }).catch((err) => {
                    console.log(err)
                });
        },
        getJobfairJobs: function(){
            new this.$apiAction().getJobfairJobs(this.jobfair_id, this.token).then((res) => {
                if(res.status == true) {
                    this.job_fair_jobs = res.jobs;
                }
            }).catch((err) => {
                console.log(err)
            });
        },
        addJobs: function() {
            let data = [];
            this.selected_jobs.forEach(job => {
                data.push({
                    job_fair_id: this.jobfair_id,
                    job_id: job
                })
            });
            new this.$apiAction().addJobs(data, this.token).then((res) => {
                    if(res.status == true) {
                       this.getJobfairJobs();
                       this.loadJobs();
                       this.selected_jobs = []; 
                    }
                }).catch((err) => {
                    console.log(err)
                });
        },
        removeJob: function(job_id) {
            new this.$apiAction().removeJobfromJobfair(this.jobfair_id,job_id, this.token).then((res) => {
                if(res.status == true) {
                    this.getJobfairJobs();
                    this.loadJobs();
                }
            }).catch((err) => {
                console.log(err)
            });
        },
        getDate(ts){
            var timestamp = ts * 1000;
            var date = new Date(timestamp);
            return date.getDate()+
                "-"+(date.getMonth()+1)+
                "-"+date.getFullYear()
        },
        hasDupes(array, value) {
            return array.some(function (a) {
                return a.job_id == value
            });
        },
        getStatus(status) {
            switch(status) {
                case 0: return 'Pending'; 
                case 1: return 'Active'; 
                case 2: return 'Inactive'; 
                case 3: return 'Rejetced'; 
                case 4: return 'Deleted'; 
                case 5: return 'Archived'; 
                case 6: return 'on hold'; 
                default: break;
            }
        },
    }
}
</script>